module.exports = require('./lib/_stream_duplex.js');



//////////////////
// WEBPACK FOOTER
// ./~/readable-stream/duplex-browser.js
// module id = 1125
// module chunks = 0